import { Component } from 'react'
import PropTypes from 'prop-types'

class TextField extends Component {
    state = { focused: false }

    onFocus = () => {
        this.setState({ focused: true })
        if (this.props.onFocus)
            this.props.onFocus()
    }
    onBlur = () => {
        this.setState({ focused: false })
        if (this.props.onBlur)
            this.props.onBlur()
    }

    render() {
        const { placeholder, label, disabled, value, onFocus, onBlur, required, ...remainingProps } = this.props

        let className = 'text-field'
        if (value || placeholder || this.state.focused)
            className += ' text-field--label-raised'
        if (this.state.focused)
            className += ' text-field--focused'
        if (disabled)
            className += ' text-field--disabled'

        return (
            <label className={className}>
                <span className="text-field__span">{label + (required ? '*' : '')}</span>
                <input 
                    type="text"
                    value={value}
                    placeholder={placeholder}
                    disabled={disabled}
                    required={required}
                    {...remainingProps}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur} />
            </label>
        )
    }
}

TextField.propTypes = {
    label: PropTypes.string.isRequired,
}

export default TextField